import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'

import { SubjectApiResponse } from '../../common/subjectTypes'
import { AsyncState } from '../../redux/fetchAction'
import { useAppSelector } from '../../redux/hooks'

export const useFetchSubjectDetail = (subjectId?: string) => {
  const { token } = useAppSelector(state => state.myProfile)

  const [state, setState] = useState<AsyncState<SubjectApiResponse>>({
    fetching: true,
    data: null,
    error: false,
  })

  const fetchSubjectDetail = useCallback(async () => {
    if (!subjectId || !token) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
      return
    }

    setState({
      fetching: true,
      data: null,
      error: false,
    })

    try {
      const response = await axios.get<SubjectApiResponse>(
        `https://data.regesta.cz/DrmApi/api/v1.0/Subjekty/${subjectId}?access_token=${token}`
      )
      setState({
        fetching: false,
        data: response.data,
        error: false,
      })
    } catch (error) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
    }
  }, [subjectId, token])

  useEffect(() => {
    fetchSubjectDetail()
  }, [fetchSubjectDetail])

  return state
}
